import { useState } from 'react';
import { Outlet, ScrollRestoration } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
import { CartDrawer } from '@/components/cart/CartDrawer';

export function Layout() {
  const [cartOpen, setCartOpen] = useState(false);

  return (
    <>
      <a className="skip-link" href="#main">
        Skip to content
      </a>
      <Header onOpenCart={() => setCartOpen(true)} />
      <main id="main" className="container" style={{ paddingBlock: 'var(--space-8)' }}>
        <Outlet context={{ openCart: () => setCartOpen(true) }} />
      </main>
      <Footer />
      <CartDrawer open={cartOpen} onClose={() => setCartOpen(false)} />
      <ScrollRestoration />
    </>
  );
}
